import * as Api from '@ViewModels';
import { UserReference } from '../extViewmodels/sdk/models/User';

/** Scores still report their source's scope as the legacy integer, not `Api.AIAgentTemplateScope`. */
export enum KeepInTouchJobConfigurationScope {
	User = 0,
	Account = 1,
}

export type KeepInTouchTemplateRequest = Pick<
	Api.KeepInTouchTemplate,
	'name' | 'audiencePrompt' | 'objectivePrompt' | 'scheduleEnabled'
> & {
	scope: Api.AIAgentTemplateScope.User | Api.AIAgentTemplateScope.Account;
	scheduleEnabled: boolean;
};

export type KeepInTouchScoreStatus = 'Success' | 'Failed' | 'Skipped';

export interface IKeepInTouchScore {
	id: string;
	jobConfigurationId: string;
	contactId: string;
	contactOwnerId: string | null;
	jobConfigurationScope: KeepInTouchJobConfigurationScope;
	jobConfigurationCreatorId: string | null;
	score: number;
	reasoning: string | null;
	suggestedOutreach: string | null;
	webFindings: string | null;
	daysSinceLastContact: number | null;
	contactName: string | null;
	companyName: string | null;
	status: KeepInTouchScoreStatus;
	notes: string | null;
	skip: boolean;
	acknowledgedDate: string | null;
	creator: UserReference | null;
	creationDate: string;
	lastModifiedDate: string;
}

export interface IKeepInTouchScoreUpdateRequest {
	notes: string;
	skip: boolean;
}

export type KeepInTouchJobStatus = 'Queued' | 'InProgress' | 'Complete' | 'PartialSuccess' | 'Failed';

export interface IKeepInTouchProgressEntry {
	message: string;
	timestamp: string;
}

export interface IKeepInTouchContactResult {
	contactId: string;
	contactName: string | null;
	status: KeepInTouchScoreStatus;
}

export interface IKeepInTouchSystemJob {
	id: string;
	status: KeepInTouchJobStatus;
	percentComplete: number;
	contactIds: string[];
	jobConfigurationId: string | null;
	templateId: string | null;
	currentContactName: string | null;
	currentIndex: number;
	results: IKeepInTouchContactResult[];
	progressLog: IKeepInTouchProgressEntry[];
}

export const TERMINAL_JOB_STATUSES: KeepInTouchJobStatus[] = ['Complete', 'PartialSuccess', 'Failed'];
